import _ from 'lodash';
import { camelCase, startCase } from 'lodash/string';

export default class AddonListCtrl {
  constructor(Ledger, AddOn) {
    this.AddOn = AddOn;
    this.volumeLabels = Ledger.volumeLabels;
  }

  reorderAddon(list, addon) {
    const index = list.indexOf(addon);

    list.splice(index, 1);

    const newIndex = _.findIndex(list, { id: addon.id });
    const nextAddon = list[newIndex + 1] || list[newIndex - 1];

    this.onReorder(addon.id, nextAddon.id);
  }

  capitalizeText(text) {
    return startCase(camelCase(text));
  }
}
